import { acceptHMRUpdate, defineStore } from 'pinia';
import {
  DesiredIndusty,
  ResumeLanguage,
  CandidateDaxtraJsons,
  DesiredIndustrySecondary,
  CandidateResumeIndustry,
} from '@/types/pages/candidate/OptionalInformation';
import { OptionalInformationType } from '@/types/pages/candidate/OptionalInformation';

const initialState: OptionalInformationType = {
  native_language_id: undefined,
  resume_industries: [],
  candidate_resume_industries: [],
  desired_industries: [],
  resume_languages: [],
  desired_occupations: [],
  desired_annual_income: '',
  qualifications_description: '',
  special_remarks: '',
  profile_desired_industires: [],
  candidate_daxtra_jsons: [],
  is_mail_magazine_subscribed: true,
  desired_locations: [],
  language_remarks: '',
  willingness: 'have_chance',
};

export const useOptionalInformationStore = defineStore('optionalInformation.store', {
  state: (): OptionalInformationType => ({ ...initialState }),
  actions: {
    createIndustires(industires: DesiredIndusty[]) {
      this.desired_industries = industires.map(industy => ({
        industry_id: industy.industry_id,
        name: industy.name,
        index: industy.index,
      }));
    },
    deleteIndustry(index: number) {
      this.desired_industries = this.desired_industries.filter((item: any) => item.index != index);
    },
    setResumeLanguages(resume_languages: ResumeLanguage[]) {
      this.resume_languages = resume_languages.map(language => ({
        id: language.id,
        other_language_id: language.other_language_id,
        other_language_level_id: language.other_language_level_id,
        index: language.index,
      }));
    },
    setResumeIndustires(resume_industires: CandidateResumeIndustry[]) {
      this.candidate_resume_industries = resume_industires.map(industry => ({
        id: industry.id,
        industry_id: industry.industry_id,
        years_of_experience: industry.years_of_experience,
        index: industry.index,
      }));
    },
    setDesiredIndustries(desired_industires: DesiredIndustrySecondary[]) {
      this.desired_industries = desired_industires.map(industry => ({
        industry_id: industry.industry_id,
        name: industry.name,
      }));
    },
    setDesiredOccupations(desired_occupations: any[]) {
      this.desired_occupations = desired_occupations.map(occupation => ({
        occupation_id: occupation.occupation_id,
        name: occupation.name,
      }));
    },
    setDesiredLocations(desired_locations: any[]) {
      this.desired_locations = desired_locations.map((location: any) => ({
        id: location.id,
        name: location.name,
        prefecture_id: location.prefecture_id,
        prefecture_name: location.prefecture_name,
      }));
    },
    setOptionalInformationData(data: any) {
      if (data.desired_annual_income) this.desired_annual_income = data.desired_annual_income;
      if (data.desired_industries) this.desired_industries = data.desired_industries;
      if (data.desired_occupations) this.desired_occupations = data.desired_occupations;
      if (data.desired_locations) this.desired_locations = data.desired_locations;
      if (data.willingness) this.willingness = data.willingness;
    },
    removeDesiredIndustry(industryId: number) {
      this.desired_industries = this.desired_industries.filter(
        industry => industry.industry_id !== industryId
      );
    },
    removeDesiredOccupation(occupationId: number) {
      this.desired_occupations = this.desired_occupations.filter(
        occupation => occupation.occupation_id !== occupationId
      );
    },
    removeDesiredLocation(locationId: number) {
      this.desired_locations = this.desired_locations.filter(
        (location: any) => location.id !== locationId
      );
    },
    setCandidateDaxtraJsons(candidateDaxtraJsons: CandidateDaxtraJsons[]) {
      this.candidate_daxtra_jsons = candidateDaxtraJsons.map(json => ({
        id: json.id,
        name: json.name,
        file_type: json.file_type,
      }));
    },
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useOptionalInformationStore, import.meta.hot));
}
